<!--
 * @Descripttion:
 * @version:
 * @Author: AowCt <awoct10@163.com>
 * @Date: 2021-11-08 19:17:40
 * @LastEditors: AowCt <awoct10@163.com>
 * @LastEditTime: 2023-04-06 18:00:37
-->
<template>
  <div class="index-partner wh100">
    <div class="ui-index-title p-t-10">{{ $t('frontPage.partner.title') }}</div>
    <div class="partner-menu flex justify_content_center">
      <div :class="['partner-menu-item', typeActive == 0 ? 'active' : '']" @click="menuClick(0)">{{ $t('frontPage.partner.type[0]') }}</div>
      <div :class="['partner-menu-item', typeActive == 1 ? 'active' : '']" @click="menuClick(1)">{{ $t('frontPage.partner.type[1]') }}</div>
    </div>
    <div :class="['clearfix index-partner-type']">
      <div v-if="typeActive == 0" class="index-partner-type-item skull">
        <img class="index-partner-type-img img1" :src="require('@/assets/images/index/partner/skull1.png')" alt="" srcset="">
        <img class="index-partner-type-img img2" :src="require('@/assets/images/index/partner/skull2.png')" alt="" srcset="">
        <div class="flex justify_content_center flex_col hei100 posrel">
          <div class="index-partner-type-title">{{ $t('frontPage.partner.skull.title') }}</div>
          <div>{{ $t('frontPage.partner.skull.des') }}</div>
        </div>
      </div>
      <div v-if="typeActive == 1" class="index-partner-type-item heart">
        <img class="index-partner-type-img img1" :src="require('@/assets/images/index/partner/heart1.png')" alt="" srcset="">
        <img class="index-partner-type-img img2" :src="require('@/assets/images/index/partner/heart2.png')" alt="" srcset="">
        <div class="flex justify_content_center flex_col hei100 posrel">
          <div class="index-partner-type-title">{{ $t('frontPage.partner.heart.title') }}</div>
          <div>{{ $t('frontPage.partner.heart.des') }}</div>
        </div>
      </div>
    </div>
    <div :class="['swiper overhid index-partner-swiper m-t-20']">
      <template v-if="language == 'en'">
        <div class="swiper-wrapper">
          <div class="swiper-slide index-partner-slide clearfix" v-for="(item, index) in 3" :key="index">
            <div class="index-partner-slide-item flex flex_wrap">
              <div class="index-partner-slide-img flex justify_content_center align_items_center" v-for="($item, $index) in 4" :key="$index">
                <img class="" :src="require(`@/assets/images/index/partner/en/${typeActive == 0 ? 'skull' : 'heart'}_${index * 4 + $index + 1}.png`)" alt="" srcset="">
              </div>
            </div>
          </div>
        </div>
      </template>
      <template v-else>
        <div class="swiper-wrapper">
          <div class="swiper-slide index-partner-slide clearfix" v-for="(item, index) in 5" :key="index">
            <div class="index-partner-slide-item flex flex_wrap">
              <div class="index-partner-slide-img flex justify_content_center align_items_center" v-for="($item, $index) in 4" :key="$index">
                <img class="" :src="require(`@/assets/images/index/partner/${typeActive == 0 ? 'skull' : 'heart'}_${index * 4 + $index + 1}.png`)" alt="" srcset="">
              </div>
            </div>
          </div>
        </div>
      </template>
      <div class="swiper-pagination partner-pagination"></div>
    </div>
  </div>
</template>
<script>
import { mapGetters } from 'vuex'
export default {
  data () {
    return {
      typeActive: 0,
      mySwiper: null
    }
  },
  computed: {
    ...mapGetters(['language'])
  },
  mounted () {
    this.mySwiper = new this.$Swiper('.index-partner-swiper', {
      autoplay: {
        disableOnInteraction: false
      },
      loop: true,
      observeParents: true, // 修改swiper的父元素时，自动初始化swiper
      pagination: {
        el: '.partner-pagination',
        bulletElement: 'li',
        clickable: true
      }
    })
  },
  methods: {
    menuClick (index) {
      this.mySwiper.autoplay.stop()
      this.typeActive = index
      this.$nextTick(() => {
        this.mySwiper.slideTo(1, 0, false)
        this.mySwiper.autoplay.start()
      })
    }
  },
  beforeDestroy () { // 页面关闭时清除定时器
    this.mySwiper = null
  }
}
</script>

<style lang="less" scoped>
.m .index-partner {
  color: #333333;
  padding-top: 30px;
  border-top: 1px solid #E8E8E8;
  .partner-menu {
    padding: 30px 0;
    .partner-menu-item {
      height: 50px;
      border: 1px solid #00A0E9;
      color: #00A0E9;
      font-size: 24px;
      padding: 0 22px;
      line-height: 50px;
      background: #ffffff;
      &:first-child {
        border-radius: 25px 0px 0px 25px;
      }
      &:last-child {
        border-radius: 0px 25px 25px 0px;
      }
      &.active {
        background: #00A0E9;
        color: #ffffff;
      }
    }
  }
  .index-partner-type {
    position: relative;
  }
  .index-partner-type-item {
    height: 260px;
    width: 100%;
    background: #00A0E9;
    position: relative;
    color: #ffffff;
    text-align: center;
    font-size: 18px;
    &.heart {
      background: #BD1D10;
    }
    .index-partner-type-img {
      position: absolute;
      max-height: 80%;
      bottom: 10px;
      &.img1 {
        left: 0;
      }
      &.img2 {
        right: 0;
      }
    }
    &:not(.skull) {
      .img1 {
        animation: scale1 3s linear infinite;
      }
    }
    .index-partner-type-title {
      width: 100%;
      font-size: 30px;
      line-height: 42px;
      padding-bottom: 40px;
      position: relative;
    }
  }
  .index-partner-swiper {
    position: relative;
    padding: 10px 0 60px 0;
  }
  .swiper-slide {
    background: #ffffff;
    .index-partner-slide-item {
      position: relative;
      .index-partner-slide-img {
        width: 50%;
        height: 140px;
        margin: 20px 0;
        img {
          max-width: 80%;
          max-height: 120px;
        }
      }
    }
  }
}
</style>
<style lang="less">
.index-partner {
    .swiper-pagination {
      position: relative;
      top: 30px;
      .swiper-pagination-bullet {
        background: #D8D8D8;
        margin-right: 34px;
        width: 12px;
        height: 12px;
        opacity: 1;
        &:last-child {
          margin-right: 0;
        }
        &.swiper-pagination-bullet-active {
          background: #00A0E9;
        }
      }
    }
}
</style>
